<template>
    <div>
        
    </div>
</template>
<script>
import {domain} from '@/utils/utils.js'
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      
    };
  },
  created(){
    const code = this.getUrlParam('code')
    if (code) {
        this.getAuthOpen(code)
      }
  },
  methods:{
    ...mapActions([
        'setLoginInfo',
      'authSitOpens',
      'setLoginStus',
      'setNavRoute'
    ]),
    getUrlParam(name) {
        let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
        let r = window.location.search.substr(1).match(reg);
        if (r != null) {
            return unescape(r[2]);
        }
        return null;
    },
    async getAuthOpen(code,state){
      let info=new Object()
      info.code=code
      const result= await this.authSitOpens(info)
      if(result.code=='1'){
          let res=result.data
          this.setLoginInfo(res)
            if(res.mobile){
                this.setNavRoute()
                this.setLoginStus(true)
            }else{
                this.$router.replace({name:'bindTel'});
            }
            
      }
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/auth.vue